import PropTypes from 'prop-types'

import { translate } from '@/utils/translations'

import TabNavItem from '../TabNavItem'
const NAV_KEY = 'details'

const DetailsNavItem = ({ handleOnClick }) => (
  <TabNavItem
    condition
    eventKey={NAV_KEY}
    setEventKey={handleOnClick}
    title={translate('common.description')}
  />
)

export default DetailsNavItem

DetailsNavItem.propTypes = { handleOnClick: PropTypes.func.isRequired }
